import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=3ed64282&scoped=true&"
import script from "./GoodsInfo.vue?vue&type=script&lang=js&"
export * from "./GoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GoodsInfo.vue?vue&type=style&index=1&id=3ed64282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed64282",
  null
  
)

export default component.exports